import type { BuyerStatus, BuyerSubStatus } from "@getbread/api-client-buyer-v2";
import { useFlag } from "../components/FeatureFlagProvider";
import { useCurrentBuyer } from "./useCurrentBuyer";

const useIsSystemicChargeOffBuyer = () => {
	const { status, subStatus } = useCurrentBuyer();
	const isCollectionsChargeOffFlowEnabled = useFlag("useCollectionsChargeOffFlow");

	const systemicChargeOffStatuses = {
		isFraudClaimReceived: false,
		isFraudClaimPending: false,
		isDeceasedConfirmed: false,
		isFraudClaimConfirmed: false,
	};

	const statusKeyMap: Partial<
		Record<
			BuyerStatus,
			Partial<Record<BuyerSubStatus, keyof typeof systemicChargeOffStatuses>>
		>
	> = {
		FRAUDULENT: {
			RECEIVED: "isFraudClaimReceived",
			PENDING: "isFraudClaimPending",
			CONFIRMED: "isFraudClaimConfirmed",
		},
		DECEASED: {
			DECEASED: "isDeceasedConfirmed",
			CONFIRMED: "isDeceasedConfirmed",
		},
	};

	if (
		isCollectionsChargeOffFlowEnabled &&
		status &&
		statusKeyMap[status] &&
		subStatus &&
		statusKeyMap[status][subStatus]
	) {
		const key = statusKeyMap[status][subStatus];
		systemicChargeOffStatuses[key] = true;
	}

	return systemicChargeOffStatuses;
};

export { useIsSystemicChargeOffBuyer };
